import { ReactNode } from 'react';
import MainNavbar from './MainNavbar';
import SecondaryNavbar from './SecondaryNavbar';
import Footer from './Footer';

interface LayoutProps {
  children: ReactNode;
  hideNavbar?: boolean;
  hideSecondaryNavbar?: boolean;
  hideFooter?: boolean;
}

export default function Layout({
  children,
  hideNavbar = false,
  hideSecondaryNavbar = false,
  hideFooter = false,
}: LayoutProps) {
  return (
    <div className="flex flex-col min-h-screen bg-offwhite">
      {!hideNavbar && <MainNavbar />}
      {!hideSecondaryNavbar && <SecondaryNavbar />}
      <main className={`flex-1 ${!hideNavbar && !hideSecondaryNavbar ? 'pt-28 md:pt-32' : ''}`} role="main">
        {children}
      </main>
      {!hideFooter && <Footer />}
    </div>
  );
}
